import React from 'react';
import appApi from '../../../api/app-api';
import { toast } from 'react-toastify';

export const cancelDonationOperation = async (
  donorId: number,
  donationId: number,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  onSuccess?: () => void,
) => {
  try {
    setIsLoading(true);
    await appApi.updateDonationStatus(donorId, donationId, 'cancelled');
    toast.success('התרומה בוטלה בהצלחה');
    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    console.error('Error cancelling donation:', error);
    toast.error('שגיאה בביטול התרומה');
  } finally {
    setIsLoading(false);
  }
};
